import { useNavigate } from 'react-router-dom'
import type { CSSProperties } from 'react'

export interface BackLinkProps {
  // Where to go if the user came directly to this page (no history to pop).
  // Should be the natural parent page — e.g. `/prints/filament` for spool forms.
  fallback: string
  // Optional override of the label (default is "← Back").
  label?: string
}

export function BackLink({ fallback, label = '← Back' }: BackLinkProps) {
  const navigate = useNavigate()
  const style: CSSProperties = {
    display: 'inline-block',
    background: 'transparent',
    border: 'none',
    color: 'var(--color-text-muted)',
    fontSize: 'var(--font-size-sm)',
    fontWeight: 600,
    padding: 'var(--space-2) 0',
    marginBottom: 'var(--space-2)',
    cursor: 'pointer',
    textDecoration: 'none',
    fontFamily: 'inherit',
  }
  const onClick = () => {
    // history.length > 1 means there's something to go back to. Otherwise the
    // user landed here directly (deep link / refresh) — send them home base.
    if (window.history.length > 1) {
      navigate(-1)
    } else {
      navigate(fallback)
    }
  }
  return (
    <button type="button" onClick={onClick} style={style}>
      {label}
    </button>
  )
}
